
import React from "react";
import { cn } from "@/lib/utils";

interface InputFeedbackProps {
  hint?: string;
  error?: string;
}

const InputFeedback: React.FC<InputFeedbackProps> = ({ hint, error }) => {
  if (error) {
    return <p className="text-xs text-destructive animate-fade-in">{error}</p>;
  }
  
  if (hint) {
    return <p className="text-xs text-muted-foreground">{hint}</p>;
  }
  
  return null;
};

export default InputFeedback;
